var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "nonzero",
    d: "M9.07106781,9.07106781 L9.07106781,6.07106781 C9.07106781,5.51878306 9.51878306,5.07106781 10.0710678,5.07106781 C10.6233526,5.07106781 11.0710678,5.51878306 11.0710678,6.07106781 L11.0710678,9.07106781 L14.0710678,9.07106781 C14.6233526,9.07106781 15.0710678,9.51878306 15.0710678,10.0710678 C15.0710678,10.6233526 14.6233526,11.0710678 14.0710678,11.0710678 L11.0710678,11.0710678 L11.0710678,14.0710678 C11.0710678,14.6233526 10.6233526,15.0710678 10.0710678,15.0710678 C9.51878306,15.0710678 9.07106781,14.6233526 9.07106781,14.0710678 L9.07106781,11.0710678 L6.07106781,11.0710678 C5.51878306,11.0710678 5.07106781,10.6233526 5.07106781,10.0710678 C5.07106781,9.51878306 5.51878306,9.07106781 6.07106781,9.07106781 L9.07106781,9.07106781 Z",
    transform: "rotate(45 10.071 10.071)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormal);
export default __webpack_public_path__ + "static/media/normal.2b5081c438789f4842826fc6f4f06873.svg";
export { ForwardRef as ReactComponent };